import React, { useRef } from 'react';
import { MdCalendarToday } from 'react-icons/md';
import './MonthPicker.css';

function MonthPicker({ value, onChange, label, required = false, hasError = false }) {
  const inputRef = useRef(null);

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.showPicker?.();
    }
  };

  const formatDisplayMonth = (dateString) => {
    if (!dateString) return 'Selecione o mês';
    try {
      // Extrair ano e mês da string (pode vir como YYYY-MM-DD ou YYYY-MM)
      let yearMonth;
      if (dateString.includes('-')) {
        const parts = dateString.split('-');
        yearMonth = `${parts[0]}-${parts[1]}`;
      } else {
        return 'Selecione o mês';
      }
      
      const [year, month] = yearMonth.split('-');
      const monthNum = parseInt(month, 10);
      const yearNum = parseInt(year, 10);
      
      if (isNaN(monthNum) || isNaN(yearNum) || monthNum < 1 || monthNum > 12) {
        return 'Selecione o mês';
      }
      
      return `${String(monthNum).padStart(2, '0')}/${yearNum}`;
    } catch {
      return 'Selecione o mês';
    }
  };

  // Converter data completa para formato YYYY-MM para o input
  const getMonthValue = (dateString) => {
    if (!dateString) return '';
    try {
      // Extrair apenas YYYY-MM (ignorar o dia se existir)
      if (dateString.includes('-')) {
        const parts = dateString.split('-');
        return `${parts[0]}-${parts[1]}`;
      }
      return '';
    } catch {
      return '';
    }
  };

  // Converter YYYY-MM para YYYY-MM-DD (primeiro dia do mês)
  const handleMonthChange = (monthValue) => {
    if (monthValue) {
      onChange(`${monthValue}-01`);
    } else {
      onChange('');
    }
  };

  return (
    <div className="monthpicker-wrapper">
      {label && (
        <label className="monthpicker-label">
          {label}
          {required && <span className="required-mark">*</span>}
        </label>
      )}
      
      <div className={`monthpicker-container ${hasError ? 'error' : ''}`} onClick={handleClick}>
        <div className="monthpicker-icon">
          <MdCalendarToday size={20} />
        </div>
        
        <div className="monthpicker-display">
          {formatDisplayMonth(value)}
        </div>

        <input
          ref={inputRef}
          type="month"
          value={getMonthValue(value)}
          onChange={(e) => handleMonthChange(e.target.value)}
          required={required}
          className="monthpicker-input"
        />
        
        <div className="monthpicker-arrow">
          <MdCalendarToday size={18} />
        </div>
      </div>
    </div>
  );
}

export default MonthPicker;
